export const lg_menu_mainpage_bottom = {
    lg_menu_mainpage_bottom_th: [
       ["mdi-login", "เข้าสู่ระบบ", "/login-account"],
      ["mdi-account", "ลงทะเบียน", "/register-account"],
       
      ],
    lg_menu_mainpage_bottom_en: [
        ["mdi-login", "Login", "/login-account"],
        ["mdi-account", "Sign Up", "/register-account"],
    
      ],
  };
  